import { render } from "./MessageHeader.vue?vue&type=template&id=142af4bd&ts=true"
import script from "./MessageHeader.vue?vue&type=script&lang=ts"
export * from "./MessageHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__